<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'RemoteLock'"
      
      [customBack]="'integration/all'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'TIDY will automatically generate a lock code through RemoteLock for each job.'" /><span>&nbsp;</span>
          <tidy-text
            [actionBody]="'Learn More'"
            (action)="goToLearnMore()"
            class="link" />
        </tidy-row>
        @if (addresses?.length > 3) {
          <tidy-alert>
            <form [formGroup]="form" novalidate action="#">
              <tidy-row class="field-top-padding" style="padding-bottom:0px">
                <tidy-input
                  #searchInput
                  [icon]="'assets/svg/search.svg'"
                  [noBorder]="true"
                  type="search"
                  formControlName="search"
                  [label]="'Search'"
                  [form]="form" />
              </tidy-row>
            </form>
          </tidy-alert>
        }
        @for (address of addresses; track address; let last = $last) {
          <tidy-card>
            <tidy-card-button (action)="goToEditAddressLockPage(address)">
              <tidy-row class="vertical-align-center">
                @if (address?.remote_access_address) {
                  <tidy-image
                    [src]="'assets/img/checkmark.svg'"
                    class="header-size" />
                }
                @if (!address?.remote_access_address) {
                  <tidy-image
                    [src]="'assets/img/block.svg'"
                    class="body-size" />
                }
                @if (!address?.address_name) {
                  <tidy-text
                    [body]="address?.address1 + ' '"
                    [translate]="false" />
                }
                @if (address?.address_name) {
                  <tidy-text
                    [body]="address?.address_name"
                    [translate]="false" />
                }
              </tidy-row>
              @if (address?.address2 !== null && address?.address2 !== '' && !address?.address_name) {
                <tidy-row>
                  <tidy-text
                    [body]="address?.address2" />
                </tidy-row>
              }
              <tidy-row>
                @if (address?.city !== null && address?.city !== '') {
                  <tidy-text
                    [helper]="address?.city" />
                }
                @if (address?.zip !== null && address?.zip !== '') {
                  <tidy-text
                    [helper]="', ' + address?.zip">>
                  </tidy-text>
                }
              </tidy-row>
              @for (device of getInUseDevices(address?.remote_access_address?.remote_access_devices); track device) {
                <tidy-row class="vertical-align-center extra-top-padding">
                  <tidy-image
                    [src]="'assets/img/lock-grey.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="device?.device_name"
                    [translate]="false" />
                </tidy-row>
              }
              @if (getInUseDevices(address?.remote_access_address?.remote_access_devices)?.length == 0) {
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [helper]="'No Devices Integrated'" />
                </tidy-row>
              }
            </tidy-card-button>
          </tidy-card>
        }
      }
    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
